import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { setCurrentNavPage } from 'actions';
import _ from 'i18n';
import ReactTooltip from 'react-tooltip';
import { getTextByLanguage } from 'surveyUtils';
import { STATS_COLORS } from 'SurveyConfig';
import BooleanChart from '../charts/BooleanChart';
import NoData from '../charts/NoDataChart';

export const BooleanStats = (props) => {
  const { lng, data, nbResponses } = props;
  const { text, id } = data.question;
  const { nbResponse } = data.stats;
  const idTooltip = `responses-qst-${id}`;

  return (
    <div className="column column-block">
      <div className="summary__qst">
        <div className="column">
          <div className="title">{getTextByLanguage(text, lng)}</div>
          <div className="responses">
            <span data-tip data-for={idTooltip}>
              {nbResponse}
              {'/'}
              {nbResponses}
            </span>
            <ReactTooltip id={idTooltip} multiline={true} className="react-tooltip">
              <span className="tooltip-content">
                {`${nbResponse} ${_('out of')} ${nbResponses} ${_('people answered this question')}`}
              </span>
            </ReactTooltip>
          </div>
          {
            nbResponse != 0
              ? <BooleanChart data={data.stats.data} type={data.question.type} startColorIndex={id % STATS_COLORS.length} />
              : <NoData />
          }
        </div>
      </div>
    </div>
  );
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ setCurrentNavPage }, dispatch);
}

const mapStateToProps = state => ({
  lng: state.params.lng,
});

export default connect(mapStateToProps, mapDispatchToProps)(BooleanStats);
